import './SliderV2.css'

export function SliderV2({
  min,
  max,
  value,
  onChange,
  step = 1,
  onMouseUp,
  name
}: {
  min: number
  max: number
  value: number
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  step?: number
  onMouseUp?: (evt: React.SyntheticEvent<HTMLInputElement>) => void
  name?: string
}) {
  return (
    <div className="slider-v2-container">
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        step={step}
        onMouseUp={onMouseUp}
        onTouchEnd={onMouseUp}
        onChange={onChange}
        name={name}
        className="slider-v2-input"
      />
    </div>
  )
}
